<h2 mat-dialog-title class="font-medium p-2 px-6">Please select your highest qualification</h2>

<mat-dialog-content class="p-4">

    <div class="mb-4 leading-6">
        The degree that you selected has two possible gowns based on your highest qualification.  Please select your highest undergrade qualification.
    </div>


    <div class="flex">

        <div class="mr-4 w-40 h-24 p-4 cursor-pointer hover:bg-gray-200 font-medium text-2xl rounded-2xl bg-gray-100 flex items-end justify-center" (click)="degreeSelected('bachelors')">
            Bachelors
        </div>
    
        <div class="mr-4 w-40 h-24 p-4 cursor-pointer hover:bg-gray-200 font-medium text-2xl rounded-2xl bg-gray-100 flex items-end justify-center" (click)="degreeSelected('masters')">
            Masters
        </div>
    

    </div>

</mat-dialog-content>

<!-- <mat-dialog-actions align="end">
  <button mat-button mat-dialog-close cdkFocusInitial>OK</button>
</mat-dialog-actions> -->